import { render } from "./EditProfileWork.vue?vue&type=template&id=03faf010"
import script from "./EditProfileWork.vue?vue&type=script&lang=js"
export * from "./EditProfileWork.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__